export default "__VITE_ASSET__CGwxIubs__"